import { getUnitJwt } from '@/actions/authActions'
import { useAppDispatch } from '@/utils/typeHelpers'
import { useEffect, useState } from 'react'
import { Loader } from '@/ui'
import { useReselector } from '@/utils/sharedHooks'
import { selectIsImpersonating } from '@/selectors/user.selectors'
import { ImpersonationNotice } from '@/components/ImpersonationNotice'

import { UnitSessionGuard } from './UnitSessionGuard'

export const UnitBanking = () => {
  const [jwt, setJwt] = useState<string>()
  const dispatch = useAppDispatch()
  const isImpersonating = useReselector(selectIsImpersonating)

  useEffect(() => {
    if (isImpersonating) return
    const fetch = async () => {
      const res = await dispatch(getUnitJwt())
      if (res?.jwt) {
        setJwt(res.jwt)
      }
    }
    fetch()
  }, [dispatch, isImpersonating])

  if (isImpersonating) {
    return <ImpersonationNotice />
  }

  if (!jwt) {
    return <Loader />
  }

  return (
    <UnitSessionGuard>
      <unit-elements-white-label-app class="w-full" jwt-token={jwt} />
    </UnitSessionGuard>
  )
}
